import { token, me } from "@/api/auth";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    firstName: "",
    lastName: "",
    mediaUrl: "",
    siteUrl: "",
    roles: [],
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    // state.token = token;
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_FIRST_NAME: (state, firstName) => {
    state.firstName = firstName;
  },
  SET_LAST_NAME: (state, lastName) => {
    state.lastName = lastName;
  },
  SET_MEDIA_URL: (state, mediaUrl) => {
    state.mediaUrl = mediaUrl;
  },
  SET_SITE_URL: (state, siteUrl) => {
    state.siteUrl = siteUrl;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    // const { login, password } = userInfo;
    return new Promise((resolve, reject) => {
      // const params = new URLSearchParams();

      // params.append("login", login.trim());
      // params.append("password", password);

      token(userInfo)
        .then((resp) => {
          commit("SET_TOKEN", resp);
          setToken(resp);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      me()
        .then((resp) => {
          const roles = ["admin"];
          const {
            username = `admin`,
            first_name = ``,
            last_name = ``,
            media_url = "",
            site_url = "",
          } = resp;

          commit("SET_ROLES", roles);
          commit("SET_NAME", username);
          commit("SET_FIRST_NAME", first_name);
          commit("SET_LAST_NAME", last_name);
          commit("SET_MEDIA_URL", media_url);
          commit(
            "SET_SITE_URL",
            process.env.VUE_APP_SITE_URL
              ? process.env.VUE_APP_SITE_URL
              : site_url
          );

          resolve({ roles, username });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    removeToken(); // must remove  token  first
    resetRouter();
    commit("RESET_STATE");
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
